<template>
  <section>
    <v-card>
      <v-container fill-height fluid pa-2>
        <v-flex xs12 sm6 md4>
          <v-menu
            :close-on-content-click="false"
            v-model="fechaInicio"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateInicio"
              label="Seleccione fecha de inicio"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="dateInicio" @input="fechaInicio = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-menu
            :close-on-content-click="false"
            v-model="fechaFin"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFin"
              label="Seleccione fecha fin"
              prepend-icon="event"
              readonly
            ></v-text-field>
            <v-date-picker v-model="dateFin" @input="fechaFin = false"></v-date-picker>
          </v-menu>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn :loading="loading4" :disabled="loading4" color="info" @click="objetoReporte()">
          generar Reporte
          <span slot="loader" class="custom-loader">
            <v-icon light>cached</v-icon>
          </span>
        </v-btn>
        
        <v-btn color="pink" fab large dark >
              <v-icon @click="generarReportePdf()">picture_as_pdf</v-icon>
            </v-btn>
      </v-container>
      <v-container v-if="$util.isRol('DIRECTOR')" fill-height fluid pa-2>
        <v-flex>
          <v-radio-group v-model="tipo" column>
            <v-radio label="Nacional" value="nacional"></v-radio>
            <v-radio label="Departamental" value="departamental"></v-radio>
          </v-radio-group>
        </v-flex>

        <v-flex xs12 sm6 md4 v-if="tipo==='departamental'">
          <v-select
            v-model="select_departamento"
            :items="departamento"
            item-text="nombre"
            item-value="codigo"
            label="Departamento"
            persistent-hint
            return-object
          ></v-select>
        </v-flex>
      </v-container>
    </v-card>

    <v-container fluid grid-list-md>
      <v-data-iterator
        :items="items"
        :rows-per-page-items="rowsPerPageItems"
        :pagination.sync="pagination"
        content-tag="v-layout"
        row
        wrap
      >
        <v-flex slot="item" slot-scope="props" xs12 sm6 md4 lg3>
          <v-card :landscape="landscape">
            <v-card :color="props.item.color">
              <v-card-title class="blue--text">
                <h4>{{ props.item.name }}</h4>
              </v-card-title>
            </v-card>
            <v-card-text
              class="px-0 text-xs-right black--text"
            >VARON &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; MUJER</v-card-text>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-tile>
                <v-list-tile-content>NIÑO (A) (0-17):</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['0-17'].MASCULINO }}</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['0-17'].FEMENINO }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>JOVENES (18-30):</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['18-30'].MASCULINO }}</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['18-30'].FEMENINO }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>ADULTOS (31-59):</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['31-59'].MASCULINO }}</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['31-59'].FEMENINO }}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>ADULTO MAYOR (60-99):</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['60-99'].MASCULINO }}</v-list-tile-content>
                <v-list-tile-content class="align-end">{{ props.item['60-99'].FEMENINO }}</v-list-tile-content>
              </v-list-tile>
            </v-list>

            <div class="small">
              <pie-chart :chartData="props.item.chartdatas" :options="options"></pie-chart>
            </div>
          </v-card>
        </v-flex>
      </v-data-iterator>
    </v-container>
  </section>
</template>

<script>
import PieChart from './PieChart.js';

export default {
  components: {
    PieChart
  },
  mounted () {
    this.$service['get']('v1/dpas/departamentos').then(response => {
      if (response) {
        this.departamento = response;
      }
    });
  },
  data: () => ({
    rowsPerPageItems: [5, 10, 15],
    pagination: {
      rowsPerPage: 5
    },
    chartdata: null,
    options: null,
    landscape: false,
    dateInicio: new Date().toISOString().substr(0, 10),
    fechaInicio: false,
    dateFin: new Date().toISOString().substr(0, 10),
    fechaFin: false,
    loading4: false,
    items: [],
    checkbox: true,
    radioGroup: 1,
    nacional: null,
    departamental: null,
    tipo: null,
    select_departamento: { nombre: 'La Paz', codigo: '02' }
  }),
  methods: {
    objetoReporte () {
      let ruta;
      if (this.tipo === null) {
        ruta = `v1/tramites/reportes?fecha_ini=${this.dateInicio}&fecha_fin=${this.dateFin}`;
      }
      if (this.tipo === 'nacional') {
        ruta = `v1/tramites/reportes?fecha_ini=${this.dateInicio}&fecha_fin=${this.dateFin}&nal=true`;
      }
      if (this.tipo === 'departamental') {
        ruta = `v1/tramites/reportes?fecha_ini=${this.dateInicio}&fecha_fin=${this.dateFin}&dpa=${this.select_departamento.codigo}`;
      }
      this.$service['get'](ruta).then(response => {
        this.items = null;
        const lista = response;
        const listaKeys = Object.keys(response);
        this.items = [];
        this.options = {
          responsive: true,
          maintainAspectRatio: false,
          pieceLabel: {
            mode: 'percentage',
            precision: 1
          }
        };
        for (let i of listaKeys) {
          let el = {};
          el.name = i;
          el['0-17'] = lista[i]['0-17'];
          el['18-30'] = lista[i]['18-30'];
          el['31-59'] = lista[i]['31-59'];
          el['60-99'] = lista[i]['60-99'];
          let elc = {
            labels: ['Niño(a)', 'Joven', 'Adulto', 'Adulto Mayor'],
            datasets: [
              { backgroundColor: ['#42A5F5', '#B39DDB', '#CFD8DC', '#EC407A'], data: [] }
            ]
          };
          elc.datasets[0].data.push(
            parseInt(lista[i]['0-17'].FEMENINO, 10) +
              parseInt(lista[i]['0-17'].MASCULINO, 10),
            parseInt(lista[i]['18-30'].FEMENINO, 10) +
              parseInt(lista[i]['18-30'].MASCULINO, 10),
            parseInt(lista[i]['31-59'].FEMENINO, 10) +
              parseInt(lista[i]['31-59'].MASCULINO, 10),
            parseInt(lista[i]['60-99'].FEMENINO, 10) +
              parseInt(lista[i]['60-99'].MASCULINO, 10)
          );

          el.chartdatas = elc;
          this.items.push(el);
        }
      });
    },
    generarReportePdf () {
      let ruta;
      if (this.tipo === null) {
        ruta = `v1/tramites/reportesPdf?fecha_ini=${this.dateInicio}&fecha_fin=${
          this.dateFin
        }`;
      }
      if (this.tipo === 'nacional') {
        ruta = `v1/tramites/reportesPdf?fecha_ini=${this.dateInicio}&fecha_fin=${
          this.dateFin
        }&nal=true`;
      }
      if (this.tipo === 'departamental') {
        ruta = `v1/tramites/reportesPdf?fecha_ini=${this.dateInicio}&fecha_fin=${
          this.dateFin
        }&dpa=${this.select_departamento.codigo}`;
      }
      this.$service
        .get(ruta)
        .then(response => {
          let fileType = 'application/pdf';
          let name = `Reporte.pdf`;
          let a = document.createElement('a');
          a.download = name;
          a.href = window.URL.createObjectURL(
            this.b64toBlob(response, 'application/pdf')
          );
          a.dataset.downloadurl = [fileType, a.download, a.href].join(':');
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          setTimeout(() => {
            URL.revokeObjectURL(a.href);
          }, 1500);
          this.$forceUpdate();
        });
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;
      let byteCharacters = atob(b64Data);
      let byteArrays = [];
      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);
        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    onSuccess (file, response) {
      if (Object.keys(response).length > 0) {
        this.documentosAdjuntos.push(response.nombre);
      } else {
        this.$message.error('Hubo un error en subir el archivo.');
      }
    }
  }
};
</script>
<style>
.small {
  max-width: 600px;
  margin: 25px auto;
}
</style>


// WEBPACK FOOTER //
// src/components/reportes/EdadGenero.vue